import styled, { css } from 'styled-components';
import { BodyColContainer } from "../Col/BodyCol.styles";
import { HeaderColContainer } from "../Col/HeaderCol.styles";
import { BodyRowContainer } from "../Row/BodyRow.styles";
import { HeaderRowContainer } from "../Row/HeaderRow.styles";
export const RootContainer = styled.table`
  border-collapse: collapse;
  width: 100%;
  user-select: none;
  visibility: visible;

  & ${BodyColContainer}, & ${HeaderColContainer} {
    padding: ${_ref => {
  let {
    dense
  } = _ref;
  return dense ? '2px' : '12px';
}} 12px;
    &:first-child {
      border-left: 1px solid transparent;
    }
    &:last-child {
      border-right: 1px solid transparent;
    }

    ${_ref2 => {
  let {
    theme,
    dividers,
    zebra
  } = _ref2;
  return dividers && css`
        border: 1px solid ${zebra ? theme.colors.secondaryL2 : `${theme.colors.secondaryL3}33`};
      `;
}}
  }

  & ${HeaderRowContainer} {
    background-color: transparent;
  }

  & ${BodyRowContainer} {
    background-color: transparent;
    border-left: 1px solid ${_ref3 => {
  let {
    theme,
    zebra
  } = _ref3;
  return zebra ? 'transparent' : theme.colors.secondaryL2;
}};
    border-right: 1px solid ${_ref4 => {
  let {
    theme,
    zebra
  } = _ref4;
  return zebra ? 'transparent' : theme.colors.secondaryL2;
}};
    border-top: 1px solid ${_ref5 => {
  let {
    theme,
    zebra
  } = _ref5;
  return zebra ? 'transparent' : `${theme.colors.secondaryL3}33`;
}};
    border-bottom: 1px solid ${_ref6 => {
  let {
    theme,
    zebra
  } = _ref6;
  return zebra ? 'transparent' : `${theme.colors.secondaryL3}33`;
}};

    &:nth-child(odd) {
      background-color: ${_ref7 => {
  let {
    theme,
    zebra
  } = _ref7;
  return zebra ? `${theme.colors.secondaryL3}33` : 'transparent';
}};
    }
  }
`;
export const ScrollContainer = styled.div`
  padding: 10px;
  max-height: ${_ref8 => {
  let {
    maxHeight
  } = _ref8;
  return maxHeight ?? 'auto';
}};
  overflow: auto;
  visibility: hidden;
  transition: visibility 0s 1s ease-in-out;
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme?.colors?.secondaryL2;
}};
    border-radius: 10px;
  }

  &:hover {
    visibility: visible;
    transition: visibility 0.3s ease-in-out;
  }
`;